var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3211 14.7228C11.8411 17.71 14.29 20.1589 17.2772 21.6789L19.5994 19.3567C19.895 19.0611 20.3067 18.9767 20.6761 19.0928C21.8583 19.4833 23.125 19.6944 24.4444 19.6944C24.7244 19.6944 24.9929 19.8057 25.1908 20.0036C25.3888 20.2016 25.5 20.47 25.5 20.75V24.4444C25.5 24.7244 25.3888 24.9929 25.1908 25.1908C24.9929 25.3888 24.7244 25.5 24.4444 25.5C19.6853 25.5 15.121 23.6094 11.7558 20.2442C8.39057 16.879 6.5 12.3147 6.5 7.55556C6.5 7.2756 6.61121 7.00712 6.80917 6.80917C7.00712 6.61121 7.2756 6.5 7.55556 6.5H11.25C11.53 6.5 11.7984 6.61121 11.9964 6.80917C12.1943 7.00712 12.3056 7.2756 12.3056 7.55556C12.3056 8.875 12.5167 10.1417 12.9072 11.3239C13.0233 11.6933 12.9389 12.105 12.6433 12.4006L10.3211 14.7228Z",
    fill: "#0082FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBlue);
export default __webpack_public_path__ + "static/media/phone-blue.959ec586193922b615930698b706fd95.svg";
export { ForwardRef as ReactComponent };